function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Trigger cart update on cart template when quantity changes
const cartTemplateInputs = document.querySelectorAll('.cart__product-qty');
const updateCartBtn = document.querySelector('.cart__update');
const checkoutBtns = document.querySelectorAll('.cart__checkout');

let cartUpdated = false;

const debouncedOnChange = debounce((event) => {
  if (!cartUpdated) {
    // if gift feature enabled, disable checkout button until gift adding/removing complete
    if (theme.settings.enableFreeGift) {
      checkoutBtns.forEach(btn => {
        btn.classList.add('disabled');
      });
    }

    updateCartBtn.click();
  }

  cartUpdated = true;
}, 300);

cartTemplateInputs.forEach(btn => {
    btn.addEventListener('input', debouncedOnChange)
});

const freeGiftTreshold = parseInt(theme.settings.freegiftThreshold) * 100;
if (theme.settings.enableFreeGift) {
  checkFreeGiftOnLoad();    // check on load for wrong cart configurations
  document.addEventListener('cart:updated', function() {
    addFreeGift();
  });
}

function setCartAttributes(attributes = {}) {
  const result = fetch("/cart/update.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(
      {attributes: attributes}
    )
  });
}

addFreeGift = function() {
  fetch('/cart.json').then((response) => {
    const jsonPromise = response.json();
    jsonPromise.then((cart) => {
      const freeGiftProduct = cart.items.find(item => item.id == theme.settings.freegiftProduct);

      if (cart.total_price >= freeGiftTreshold) {
        if (cart.attributes.free_gift != "true" && !freeGiftProduct) {

          const freeGiftPropertyName = theme.strings.freeGiftPropertyName;
          const freeGiftProductText = theme.strings.freeGiftProductText;
          const giftProperties = {};
          giftProperties[freeGiftPropertyName] = freeGiftProductText;

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(
              {
                id: theme.settings.freegiftProduct,
                quantity: 1,
                properties: giftProperties
              }
            )
          }).then(function(response) {
            setCartAttributes({free_gift: true});

          }).then(function(response) {
            if (theme.settings.currentPageTemplate !== 'cart') {
              $('body').trigger('added.ajaxProduct', this.addToCart);
            } else {
              window.location.reload();
            }
          }).catch(function(err) {
            console.error(err)
          }).then(function() {
            checkoutBtns.forEach(btn => {
              btn.classList.remove('disabled');
            });
          });
        }

      } else { // check that there is free gift, so that we don't remove product if it's not free gift product
        if (cart.attributes.free_gift === "true" || freeGiftProduct) adjustFreeGiftQuantity();
      }
    });
  });
}

async function checkFreeGiftOnLoad() {
  const response = await fetch('/cart.json');
  const cart = await response.json();
  const freeGiftProduct = cart.items.find(item => item.id == theme.settings.freegiftProduct);
  if (!freeGiftProduct) return;
  if (cart.total_price >= freeGiftTreshold) {
    if (freeGiftProduct.quantity > 1) adjustFreeGiftQuantity(1)
  } else { // remove free gift if it's in cart
    if (freeGiftProduct.quantity > 0) adjustFreeGiftQuantity()
  }
}

async function adjustFreeGiftQuantity(qty=0) {
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(
        {id: theme.settings.freegiftProduct, quantity: qty}
      )
    });
    console.log("quantity adjusted to " + qty);
    if (qty === 0) setCartAttributes({free_gift: false});
    if (theme.settings.currentPageTemplate !== 'cart') {
      $('body').trigger('added.ajaxProduct', this.addToCart);
    } else {
      window.location.reload();
    }
  } catch (err) {
    console.error(err)
  } finally {
    checkoutBtns.forEach(btn => {
      btn.classList.remove('disabled');
    });
  }
}